<template>
    <div :key="loadComponent" :class="{ expired: event.expired }">
        {{ event.title }}
    </div>
</template>

<script>
export default {
    props: {
        event: {
            required: true,
        },
        element: {
            required: true,
        },
        config: {},
        leadTime: {},
    },
    data() {
        return {
            defaultConfig: {
                icons: false,
            },
        };
    },
    computed: {
        mergedConfig() {
            return _.defaultsDeep(this.config, this.defaultConfig);
        },
        hasErrors() {
            return _.get(this.event, 'errors', []).length && this.event.asset_type !== 'promo_bundle';
        },
    },
    watch: {
        event() {
            this.reloadComponent();
        },
        leadTimeDate() {
            this.reloadComponent();
        },
    },
};
</script>
